import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionSkillRequest,
  CvSectionSkill,
  CvSectionSkillResponse,
} from '@/../gen';

export const namespace = 'cvSectionSkillNew';
const actionCreator = actionCreatorFactory(namespace);
export const SetCvSectionSkill = actionCreator<CvSectionSkillResponse>(
  'SET_CV_SECTION_Skill'
);
export const CreateCvSectionSkill = actionCreator<{
  params: {
    cv_id: number;
  };
  body: CreateCvSectionSkillRequest;
}>('CREATE_CV_SECTION_Skill');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionSkill: CvSectionSkill;
}

const initialState = (): State => {
  return { cvSectionSkill: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(CreateCvSectionSkill, async function(context, action) {
      const { data } = await this.proffApi.createCvSectionSkill(
        action.payload.params.cv_id,
        action.payload.body
      );
      context.commit(SetCvSectionSkill(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionSkill, (state, action) => {
      state.cvSectionSkill = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionSkill: state => state.cvSectionSkill,
  },
};
